import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IReserveBreakdown } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getEarningsBreakdownConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_reserves_breakdown', timeframe)) as IReserveBreakdown[]
	const series1 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() <= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.BLOCK_REWARDS }
		})
	const series2 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: -element.GAS_REIMBURSEMENT }
	})
	const series3 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: -element.IL_PROTECTION }
	})
	const series4 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.NETWORK_FEE }
	})
	const series5 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.OUTBOUND_FEE }
	})
	const series6 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: -element.RESERVE_EXPENSE }
	})
	const series7 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RESERVE_INCOME }
	})
	const series8 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SLASHING_INCOME }
	})
	const series9 = chartData.map((element: IReserveBreakdown) => {
		if (new Date(element.DAY).getTime() / 1000 <= 1743415200) {
			return { x: new Date(element.DAY).getTime() / 1000, y: 0 }
		} else {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.LIQ_FEES_RUNE }
		}
	})
	const series10 = chartData.map((element: IReserveBreakdown) => {
		if (new Date(element.DAY).getTime() / 1000 <= 1743415200) {
			return { x: new Date(element.DAY).getTime() / 1000, y: 0 }
		} else {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.DEV_FUND_INCOME }
		}
	})
	const series11 = chartData.map((element: IReserveBreakdown) => {
		if (new Date(element.DAY).getTime() / 1000 <= 1743415200) {
			return { x: new Date(element.DAY).getTime() / 1000, y: 0 }
		} else {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.INCOME_BURN_RUNE }
		}
	})
	const series12 = chartData.map((element: IReserveBreakdown) => {
		if (new Date(element.DAY).getTime() / 1000 <= 1743415200) {
			return { x: new Date(element.DAY).getTime() / 1000, y: 0 }
		} else {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.POOL_REWARDS }
		}
	})
	const series13 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: -element.TCY_YIELD }
	})
	const series14 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: -element.MKT_FUND_INCOME }
	})
	const series15 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.BOND_REWARDS }
		})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'block rewards',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fa0202',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series15,
			strokeWidth: 2,
			name: 'bond rewards',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fa0202',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'pool rewards',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fa2c02',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series13,
			strokeWidth: 2,
			name: 'tcy yield',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fa4402',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series11,
			strokeWidth: 2,
			name: 'rune burn',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fa5902',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series10,
			strokeWidth: 2,
			name: 'dev fund',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fa7e02',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series14,
			strokeWidth: 2,
			name: 'mkt fund',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#ebfc03',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'gas reimbursement',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#9dfc03',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'IL protection',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#fac002',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'total expenses',
			type: 'line',
			seriesGroup: '[rune]',
			color: `${inverseColor}`,
			unitSymbol: 'ᚱ'
		},
		{
			data: series9,
			strokeWidth: 2,
			name: 'liquidity fees',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#2803fc',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'network fee',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#0331fc',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'outbound fee',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#036bfc',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'slashing',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#03a1fc',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'total income',
			type: 'line',
			seriesGroup: '[rune]',
			color: `${inverseColor}`,
			unitSymbol: 'ᚱ'
		}
	]

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const EarningsBreakdown = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getEarningsBreakdownConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Earnings and Distribution Breakdown"
			chartDesc={`Breakdown of the THORChain protocol earnings and how it is distributed. 
				\nRevenue sources: network fees (currently 0.02 RUNE per transaction), node slashing (network earns RUNE when a node misbehaves), outbound fee (network transaction fee when sending swap outputs to different blockchains). 
				\nExpense sources: impermanent protection (liquidity provider insurance), block rewards (liquidity provider and node incentives). Additionally, on 01.04.2025 3.4.0 update was approved which added liquidity fees as revenue and the following as expenses: pool and bond rewards, rune burn (adr17), development fund, marketing fund. 
				\n*Pool rewards includes both liquidity provider earnings and POL funding.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="b169abba-2dea-439c-9715-e0a0a4ae0319"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default EarningsBreakdown
